import { render } from "./UpcomingGroupLessons.vue?vue&type=template&id=2456a7e2"
import script from "./UpcomingGroupLessons.vue?vue&type=script&lang=js"
export * from "./UpcomingGroupLessons.vue?vue&type=script&lang=js"

import "./UpcomingGroupLessons.vue?vue&type=style&index=0&id=2456a7e2&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__